@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.imageWrapper {
    position: relative;
    overflow: hidden;
}

.asymmetricLarge {
    composes: imageWrapper;
    aspect-ratio: 1 / 1;
}

.asymmetricSmall {
    composes: imageWrapper;
    aspect-ratio: 4 / 3;
}

.symmetric {
    composes: imageWrapper;
    aspect-ratio: 5 / 6;
}

.media {
    position: absolute;
    inset: 0;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.caption {
    font: var(--font-p-14-lg);
    color: var(--dark);
    margin-top: var(--spacer-12);

    @media ($below-mobile) {
        font: var(--font-p-14-sm);
    }

    a {
        font-weight: 400;
        text-decoration: underline;
    }
}

:export {
    sizesAsymmetricLarge: string.unquote("(min-width: #{$mobile}) 58vw, 100vw");
    sizesAsymmetricSmall: string.unquote("(min-width: #{$mobile}) 42vw, 100vw");
    sizesSymmetric: string.unquote("(min-width: #{$mobile}) 42vw, 100vw");
}
